import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

//removing sub_id from api func.
export default function createAndDistributeTests(
	type,
	nKeys,
	groupId,
	language,
	anamnese,
	childSelfStarting,
	candidateEmails,
	testVersion = 'v2'
) {
	return fetch(
		`${ENDPOINT_URL}/test/createandditribute`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				type,
				nKeys,
				groupId,
				language,
				anamnese,
				childSelfStarting,
				candidateEmails,
				testVersion,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
